module.exports = __webpack_public_path__ + "img/m-a.0e878dc6.png";